import { setActiveClinicTab as setActiveClinicTabAction } from 'Redux/modules/webChat/commons/actions';
import { useSelector, useDispatch } from 'react-redux';
import { useCallback } from 'react';
import { useHistory } from 'react-router';

const useActiveClinicTab = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { activeClinicTab } = useSelector(state => state.webChat.commons);

  const setActiveClinicTab = useCallback(
    (clinicId, shallowReplace = true) => {
      dispatch(setActiveClinicTabAction(clinicId));
      if (shallowReplace) {
        history.push(`/web-chat/${clinicId}`, {}, { shallow: true });
      } else {
        history.push(`/web-chat/${clinicId}`);
      }
    },
    [dispatch, history],
  );

  return {
    activeClinicTab,
    setActiveClinicTab,
  };
};

export default useActiveClinicTab;
